import React from 'react';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../ConfirmationModal';

function SaveChangesConfirmationModal({ show, onCancel, onConfirm }) {
  return (
    <ConfirmationModal
      show={show}
      title="Save Changes"
      onCancel={onCancel}
      onConfirm={onConfirm}
      cancelButtonLabel="No"
      confirmButtonLabel="Yes"
    >
      You have modified your order items, are you sure you want to save these
      changes?
    </ConfirmationModal>
  );
}

SaveChangesConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

export default SaveChangesConfirmationModal;
